module.exports = __webpack_public_path__ + "static/media/altabank-logo.e779cf74.svg";